export default "__VITE_ASSET__B9o2gSVw__"